import { useParams,useLocation } from "react-router";
import DonsItemComponent from "../../components/Dons/DonsItem";
import { useDonsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";


function DonsItem(){
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    const params = useParams();
    const { data: don, error, isLoading } = useDonsByIdQuery((params.id)??"0");
    const {translate}=useTrads();
    
    return (
        error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        don &&
        <>
          {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_don_update')}</p>}
          <DonsItemComponent don={don}  />
        </>

    );
}
export default DonsItem;